import React, {useState} from "react";
import s from "./MyPosts.module.css";
import {Field, reduxForm} from "redux-form";
import {maxLength50, minLength2} from "../../validator/validator";
import {renderTextarea} from "../../validator/FormControl";
import {FiHeart} from 'react-icons/fi'
import avatar from '../../../assets/images/1421138632_frozen-480x800.jpg'



const MyPosts = (props) => {

     const [posts, setPosts] = useState([
         {id: 1, message: 'How are you', likesCount: 4},
         {id: 2, message: 'How are you', likesCount: 23},
         {id: 3, message: 'first like', likesCount: 1},
         {id: 4, message: 'Yo', likesCount: 7},
         {id: 5, message: 'Yo', likesCount: 12}
     ])

    let onAddPost = values => {
        let newPost = {
            id: 10,
            message: values.newPostText,
            likesCount: 0
        }
        setPosts(posts.concat(newPost))
    }
    return (
        <div className={s.postsBlock}>
            <h2>Личные сообщения </h2>
            <AddNewPostFormRedux onSubmit ={onAddPost}/>
            <div className={s.posts}>

                {posts.map(p =>
                    <div className={s.item}>
                        <img src={avatar}/>
                        <div className ={s.postElement}>{p.message}</div>
                        <div className ={s.postElement}> <FiHeart/> {p.likesCount}</div>
                    </div>
                    )}
            </div>
        </div>
    )
}
const AddNewPostForm = (props) => {
    const { handleSubmit, reset } = props
    return(
        <form onSubmit ={handleSubmit}>
            <div><Field name ="newPostText" placeholder='Enter your post!'
                        validate ={[maxLength50, minLength2]}component = {renderTextarea}/></div>
            <div><button type="submit"> Add post</button></div>
        </form>
    )
}
const AddNewPostFormRedux = reduxForm({form: 'addNewPost'})(AddNewPostForm)

export default MyPosts;